












































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/header.vue";
import { apiGetMainServer } from "./service";
import { columns } from "./config";
import { gameList } from "@/req/gameManage";
@Component({
  components: {
    headerTitle,
  },
})
export default class Home extends Vue {
  public loading = false;
  public columns = columns;
  public data = {};
  public gameList: any = [];
  public form = {
    game_id: "",
    main_serverid: "",
    server_name: "",
  };
  public gameName = "";
  public pageSize = {
    size: 10,
    page: 1,
  };
  public titleName = "";
  public mounted() {
    // this.init();
    this.getGameList();
  }
  public async getGameList() {
    const res = await gameList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      res.data.forEach((item) => {
        item.box_game_id = item.box_game_id.toString();
      });
      this.gameList = res.data;
    }
  }
  public async init(val?) {
    this.loading = true;
    if (val) {
      this.pageSize.page = 1;
    }
    const res = await apiGetMainServer({
      ...this.form,
      ...this.pageSize,
    });
    if (res.code === 0) {
      this.data = res.data;
      this.gameName = this.titleName;
    }
    this.loading = false;
  }
  public refreshClick() {
    Object.assign(this.$data, (this as any).$options.data.call(this));
    this.getGameList();
  }
  public change(index) {
    this.pageSize.page = index;
    this.init();
  }
  public onSelect(val) {
    this.titleName = val.label;
  }
}
